import { render, staticRenderFns } from "./AccordionV2.vue?vue&type=template&id=d06564e0"
import script from "./AccordionV2.vue?vue&type=script&lang=js"
export * from "./AccordionV2.vue?vue&type=script&lang=js"
import style0 from "./AccordionV2.vue?vue&type=style&index=0&id=d06564e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports